import React from 'react';

type Props = {
  className?: string;
};

const Heart: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.0288 0.5C8.00008 0.5 7.00008 2.5 7.00008 2.5C7.00008 2.5 6.00008 0.5 3.97133 0.5C2.32258 0.5 1.01695 1.87937 1.00008 3.52531C0.9657 6.94187 3.71039 9.37156 6.71883 11.4134C6.80177 11.4699 6.89976 11.5 7.00008 11.5C7.10039 11.5 7.19839 11.4699 7.28133 11.4134C10.2895 9.37156 13.0341 6.94187 13.0001 3.52531C12.9832 1.87937 11.6776 0.5 10.0288 0.5Z"
        stroke="#808080"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Heart;
